import { AutocompleteGenericEntity, DomainCode } from '@australiangreens/ag-internal-components';

import { TASK_CHOICE_MAPPING, TASK_KIND_MAPPING, TaskChoice, TaskKind } from '@/types';

export { DEFAULT_PLACEHOLDER_FIELD_LABEL } from '@/constants/searchTemplate';

export function extractNumericIdsFromGenericEntityArray(arr: AutocompleteGenericEntity[]) {
  return arr.map(({ id }) => {
    if (typeof id === 'number') return id;
    if (typeof id === 'string') return parseInt(id);
    throw new Error('Invalid id in AutocompleteGenericEntity array');
  });
}

const VALID_TASK_CHOICES = Object.keys(TASK_CHOICE_MAPPING);
export function extractTaskChoiceFromGenericEntityArray(arr: AutocompleteGenericEntity[]) {
  return arr.map(({ id }) => {
    if (typeof id === 'string' && VALID_TASK_CHOICES.includes(id)) return id as TaskChoice;
    throw new Error(`Id value '${id}' is not a valid TaskChoice`);
  });
}

const VALID_TASK_KINDS = Object.keys(TASK_KIND_MAPPING);
export function extractTaskKindFromGenericEntityArray(arr: AutocompleteGenericEntity[]) {
  return arr.map(({ id }) => {
    if (typeof id === 'string' && VALID_TASK_KINDS.includes(id)) return id as TaskKind;
    throw new Error(`Id value '${id}' is not a valid TaskKind`);
  });
}

// Subset of those supported by _ag_domain_code() in contact.greens.org.au repo
export const VALID_DOMAIN_CODES = [
  'act',
  'nsw',
  'nt',
  'qld',
  'sa',
  'tas',
  'vic',
  'wa',
  'ag',
  'fedmps',
];
export function extractDomainCodesFromGenericEntityArray(arr: AutocompleteGenericEntity[]) {
  return arr.map(({ id }) => {
    if (typeof id === 'string' && VALID_DOMAIN_CODES.includes(id)) return id as DomainCode;
    throw new Error(`Invalid domainCode '${id}'`);
  });
}
